import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["details", "frame", "radio", "spinner"];

  connect() {
    if(!this.hasFrameTarget) { return }

    this.reload();

    this.frameTarget.addEventListener("turbo:frame-render", () => {
      // Fermer le <details> uniquement au premier connect
      if (!this.hasClosedDetailsOnce) {
        this.hasClosedDetailsOnce = true;

        if (this.hasDetailsTarget) {
          this.detailsTarget.removeAttribute("open");
        }
      }
    });
  }

  reload() {
    if (!this.hasRadioTarget) return;

    let code = null;
    const checked = this.radioTargets.find(r => r.checked);
    code = checked?.value;

    if (!code) return;

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("vc-ecppp--sale-offer-estimation_block-spinner-shown");
    }

    let src = new URL(this.frameTarget.src);
    src.searchParams.delete("coopener_offer_code");
    src.searchParams.append("coopener_offer_code", code);
    this.frameTarget.src = src.toString();
    this.frameTarget.reload();
  }
}
